module.exports = __webpack_public_path__ + "img/about.5e791029.png";